import sales from './sales/sales'

export default {
  mcc: {
    ...sales
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/en/mcc/mcc.js